import { useReducer } from 'react';
function useThrowToErrorBoundary() {
  const [, setError] = useReducer((_, error) => {
    throw error;
  }, null);
  return setError;
}
export default useThrowToErrorBoundary;